import { OrderbookListAsks } from 'components/OrderbookList/Asks'
import { OrderbookListBids } from 'components/OrderbookList/Bids'
import { OrderbookTicker } from 'components/OrderbookTicker'
import { useLimitPriceCallback } from 'hooks/spot/useLimitPrice'
import { memo, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useShowListType } from 'store/orderbook/hooks'
import { ShowListType } from 'store/orderbook/types'
import { updateSpotSelectedOrderMode } from 'store/spot/actions'
import {
  useCurrentSpotSymbol,
  useSpotOpenOrders,
  useSpotSelectedOrderMode,
} from 'store/spot/hooks'
import { OrderModeNames } from 'store/spot/types'
import { OrderbookList, OrderbookTickerWrap } from './style'
import { useOrderbookList } from '../../../hooks/zkex/useOrderbookList'
import { OrderbookMarkPrice } from '../../../components/OrderbookMarkPrice'
import { OrderbookPending } from '../../../components/OrderbookList/Pending'

export const List = memo(() => {
  const dispatch = useDispatch()
  const currentSymbol = useCurrentSpotSymbol()
  const { baseScale = 0, quoteScale = 0 } = currentSymbol
  const spotSelectedOrderMode = useSpotSelectedOrderMode()
  const openOrders = useSpotOpenOrders()
  const { onLimitPriceInput } = useLimitPriceCallback()

  const showListType = useShowListType()

  const orderbookList = useOrderbookList()

  const onClickPrice = useCallback(
    async (price: string) => {
      if (spotSelectedOrderMode.name === OrderModeNames.Market) {
        dispatch(updateSpotSelectedOrderMode(OrderModeNames.Limit))
      }
      await onLimitPriceInput(price)
    },
    [dispatch, spotSelectedOrderMode, onLimitPriceInput],
  )

  if (!orderbookList) {
    return <OrderbookPending />
  }

  const { currentBuyOrders, currentSellOrders } = orderbookList

  return (
    <OrderbookList>
      {[ShowListType.all, ShowListType.sell].includes(showListType) ? (
        <OrderbookListAsks
          list={currentSellOrders}
          userOrders={openOrders}
          baseScale={baseScale}
          quoteScale={quoteScale}
          onClickPrice={onClickPrice}
        />
      ) : null}

      {showListType === ShowListType.all ? (
        <OrderbookTickerWrap>
          <OrderbookTicker quoteScale={quoteScale} />
          <OrderbookMarkPrice
            symbol={currentSymbol}
            callbackMarkPrice={onClickPrice}
          />
        </OrderbookTickerWrap>
      ) : null}

      {[ShowListType.all, ShowListType.buy].includes(showListType) ? (
        <OrderbookListBids
          list={currentBuyOrders}
          userOrders={openOrders}
          baseScale={baseScale}
          quoteScale={quoteScale}
          onClickPrice={onClickPrice}
        />
      ) : null}
    </OrderbookList>
  )
})
